import React, { FC } from 'react';
import ConfirmationModalContent from '../../ConfirmationModal/ConfirmationModalContent';
import { TGetModalComponent } from '../../Modal/useModal';
import ConfirmationModalActions from '../../ConfirmationModal/ConfirmationModalActions';
import { useAnalytics } from '../../AnalyticsProvider/AnalyticsProvider';

type TConfirmationModalProps = {
  ModalComponent: TGetModalComponent;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
};

export const CommentDeleteConfirmationModal: FC<TConfirmationModalProps> = ({
  ModalComponent,
  onConfirm,
  onCancel,
  isLoading,
}) => {
  const { sendEvent } = useAnalytics();
  const handleConfirm = () => {
    sendEvent('comment_delete_modal_confirm_click');
    onConfirm();
  };

  const handleCancel = () => {
    sendEvent('comment_delete_modal_cancel_click');
    onCancel();
  };

  return (
    <ModalComponent
      title="Delete comment"
      containerClassName="!top-[25%]"
      footer={
        <ConfirmationModalActions handleConfirm={handleConfirm} handleCancel={handleCancel} isLoading={isLoading} />
      }
    >
      <ConfirmationModalContent body="Are you sure you want to delete this comment? This action can not be undone." />
    </ModalComponent>
  );
};
